var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "ax-navbar__nav ax-utilities",
      attrs: { id: "action-menu", "aria-label": "quick action items" }
    },
    _vm._l(_vm.links, function(link) {
      return _c(
        "a",
        {
          key: link.path,
          staticClass: "ax-navbar__action-icon",
          attrs: {
            href: link.path,
            "aria-label": link.label,
            title: link.label
          }
        },
        [
          _c(link.icon, {
            tag: "component",
            staticClass: "ax-navbar__action-icon-svg",
            attrs: { role: "image", pathId: link.pathId, "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "d-none" }, [_vm._v(_vm._s(link.label))])
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }